import { Skeleton } from 'antd';
import clsx from 'clsx';
interface PageSkeletonProps {
    className?: string;
}
export function PageSkeleton({ className }: PageSkeletonProps) {
    return (
        <div
            className={clsx(
                'w-full min-h-screen p-6 space-y-6 bg-white',
                className
            )}
        >
            {/* Page title */}
            <Skeleton.Input active size="large" className="w-1/3 rounded-lg" />

            {/* Repeating content blocks (e.g., cards or list items) */}
            {[...Array(2)].map((_, i) => (
                <div
                    key={i}
                    className="w-full p-4 border border-gray-200 rounded-lg space-y-4"
                    style={{ borderColor: '#f0f0f0' }}
                >
                    <Skeleton.Input
                        active
                        size="default"
                        className="w-1/2 h-6 rounded"
                    />
                    <Skeleton
                        paragraph={{ rows: 2, width: ['80%', '100%'] }}
                        active
                    />
                </div>
            ))}
        </div>
    );
}
